// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zghRgjagKRzRcp0YObds {
    transform: translateX(-100vw);
}

.d0yL3ZfHo2af03Un8B2G {
    transform: translateX(100vw);
}

@keyframes PBjPCfeTWI4QBra3qgUo {
    from {
        transform: translateY(-40vw);
    }

    to {
        transform: translateY(0);
    }
}

.HjkCia3TTDUd8eFF3xKk {
    animation: 3s PBjPCfeTWI4QBra3qgUo;
}`, "",{"version":3,"sources":["webpack://./src/animations.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kCAA0B;AAC9B","sourcesContent":[".animate_from_left {\n    transform: translateX(-100vw);\n}\n\n.animate_from_right {\n    transform: translateX(100vw);\n}\n\n@keyframes slidefromtop {\n    from {\n        transform: translateY(-40vw);\n    }\n\n    to {\n        transform: translateY(0);\n    }\n}\n\n.animate_from_top {\n    animation: 3s slidefromtop;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animate_from_left": `zghRgjagKRzRcp0YObds`,
	"animate_from_right": `d0yL3ZfHo2af03Un8B2G`,
	"animate_from_top": `HjkCia3TTDUd8eFF3xKk`,
	"slidefromtop": `PBjPCfeTWI4QBra3qgUo`
};
export default ___CSS_LOADER_EXPORT___;
